import { useMemo } from 'react';
import { Flex } from 'antd';
import { MobileDrawer } from '@Components/index';
import TabContent from '../components/TabContent';
import { TabSelectBtn } from '../../../common/TabSelectBtn';
import { VendorPopupTab } from '../VendorPopupTab.enum';

import styles from './VendorPopup-mobile.module.css';

interface VendorPopupMobileProps {
  isOpened: boolean;
  vendorId: number;
  title: string;
  onTabChange: (tab: VendorPopupTab) => void;
  tab: VendorPopupTab;
  onClose: () => void;
}

const VendorPopupMobile: React.FC<VendorPopupMobileProps> = ({
  isOpened,
  onClose,
  title,
  vendorId,
  onTabChange,
  tab,
}) => {
  const tabSwitch = useMemo(() => {
    return (
      <Flex className={styles.tabSelectBox}>
        <TabSelectBtn
          active={tab === VendorPopupTab.VendorDetails}
          value={VendorPopupTab.VendorDetails}
          onClick={() => onTabChange(VendorPopupTab.VendorDetails)}
        >
          Details
        </TabSelectBtn>
        <TabSelectBtn
          value={VendorPopupTab.Quotation}
          active={tab === VendorPopupTab.Quotation}
          onClick={() => onTabChange(VendorPopupTab.Quotation)}
        >
          Quotation
        </TabSelectBtn>
        <TabSelectBtn
          value={VendorPopupTab.Remarks}
          active={tab === VendorPopupTab.Remarks}
          onClick={() => onTabChange(VendorPopupTab.Remarks)}
        >
          Remarks
        </TabSelectBtn>
      </Flex>
    );
  }, [tab, onTabChange]);

  return (
    <MobileDrawer open={isOpened} footer={null} title={title} onClose={onClose}>
      <Flex className={styles.mobileContainer} vertical>
        {tabSwitch}
        <TabContent selectedTab={tab} vendorId={vendorId} />
      </Flex>
    </MobileDrawer>
  );
};

export default VendorPopupMobile;
